{
  "name": "temperate",
  "ramps": {
    "ground": ["#2F5730", "#4B7A3A", "#6F9E45", "#9CBF5A"],
    "groundAlt": ["#3D6634", "#5C8A40", "#84AE50"],
    "water": ["#24557A", "#3B86A8", "#6FB7C9", "#B4DDE4"],
    "rock": ["#4A4E4D", "#6A6E6B", "#8B8F8A"],
    "dirt": ["#4A3628", "#6B4F38", "#8A6B4A"],
    "foliage": ["#2E5E34", "#3F7D3E", "#67A14B"],
    "timber": ["#3E2C20", "#5E4432", "#7E5E46"],
    "concrete": ["#4A4E4D", "#6A6E6B", "#8B8F8A"],
    "roof": ["#3D4450", "#566070"],
    "brick": ["#6E382D", "#8E4B3A", "#A96450"],
    "uniformUS": ["#2B3520", "#3F4D2B", "#5B6B3A"],
    "uniformEnemy": ["#3A403F", "#525A57", "#6F7772"]
  },
  "haze": "#CFE0D2",
  "ambientNight": "#16233A"
}
